/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteWidgetSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type DeleteWidgetRequest = {
  /**
   * The widget to delete
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteWidgetSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const DeleteWidgetSecurity$outboundSchema: z.ZodMiniType<
  DeleteWidgetSecurity$Outbound,
  DeleteWidgetSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function deleteWidgetSecurityToJSON(
  deleteWidgetSecurity: DeleteWidgetSecurity,
): string {
  return JSON.stringify(
    DeleteWidgetSecurity$outboundSchema.parse(deleteWidgetSecurity),
  );
}

/** @internal */
export type DeleteWidgetRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteWidgetRequest$outboundSchema: z.ZodMiniType<
  DeleteWidgetRequest$Outbound,
  DeleteWidgetRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteWidgetRequestToJSON(
  deleteWidgetRequest: DeleteWidgetRequest,
): string {
  return JSON.stringify(
    DeleteWidgetRequest$outboundSchema.parse(deleteWidgetRequest),
  );
}
